export const devReactApiRoot = "https://us-central1-curio-development-9ed79.cloudfunctions.net/api"
export const prodReactApiRoot = "https://us-central1-curio-5ddc0.cloudfunctions.net/api"
export const isLotusDev = process.env.REACT_APP_API_ROOT === devReactApiRoot

